<template>
  <div class="absolute w-full h-full center-in-parent bg-gray-500/50 top-0 right-0" v-if="show">
    <LoadingSpinner class="w-10 text-accent"/>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/General/LoadingSpinner";

export default {
  name: "VLoadingScreen",
  components: {LoadingSpinner},
  props: ['show']
}
</script>

<style scoped>

</style>